import type { TroubleshootingRun } from "./troubleshootingRuns.slice";
import type { RootState } from "Store/configureStore";

/**
 * The pending run for one agent activity, or undefined once its completion
 * toast has fired. The panel reads this to decide whether leaving still owes
 * the user a "started" toast.
 */
export const selectTroubleshootingRun = (
  state: RootState,
  activityId: string | undefined
): TroubleshootingRun | undefined =>
  activityId ? state.troubleshootingRuns.byActivityId[activityId] : undefined;

/**
 * The run in flight for one FAILED activity, or undefined. The CTA surfaces ask
 * with the only id they hold — the failure's — to decide between offering a run
 * and reporting the one already going.
 *
 * Deliberately not a `createSelector`. It returns the stored object itself, so
 * repeated calls are reference-stable with no memoization, and the activity list
 * can ask about several expanded rows without thrashing a size-1 cache. The scan
 * is over a record that holds one entry in practice and empties itself.
 */
export const selectTroubleshootingRunBySource = (
  state: RootState,
  sourceActivityId: string | undefined
): TroubleshootingRun | undefined =>
  sourceActivityId
    ? Object.values(state.troubleshootingRuns.byActivityId).find(
        run => run.sourceActivityId === sourceActivityId
      )
    : undefined;
